import React, { Fragment, useEffect, useState, useContext } from "react";
import styled, { css, ThemeProvider } from 'styled-components';
import theme from 'styled-theming';
import { Context } from "../context";
import { BrowserRouter as Router, Switch } from "react-router-dom";
import { Route, Redirect } from "react-router";
import './gs.css';
import './gs_add.css';
import { Layout } from './Layout';
import { dateFormat } from './utils';
import { Routes } from "./Routes";


export function Home(props) {
  const context = useContext(Context);


  const mainColors = theme('mode', {
    ...context.data.spaces.map(oneSpace => (`${oneSpace['uniq']}: ${oneSpace['color']}`))
  })


  return (<>
    {context.ready &&
      <ThemeProvider theme={{ mode: 'personal' }}>
        <Routes />
      </ThemeProvider>}
      </>
  );
}
